import React from 'react';
import { Polygon, Tooltip } from 'react-leaflet';
import type { Bed, Zone } from '../../types';
import { polygonToLatLngs } from '../../lib/utils';

interface BedPolygonProps {
  bed: Bed;
  zone: Zone | undefined;
  mapHeight: number;
  selected: boolean;
  onClick: () => void;
}

export function BedPolygon({ bed, zone, mapHeight, selected, onClick }: BedPolygonProps) {
  if (!bed.polygon_json) return null;

  const positions = polygonToLatLngs(bed.polygon_json, mapHeight);
  if (positions.length < 3) return null;

  const color = zone?.color ?? '#4ade80';

  return (
    <Polygon
      positions={positions}
      pathOptions={{
        color: selected ? '#166534' : color,
        fillColor: color,
        fillOpacity: selected ? 0.45 : 0.25,
        weight: selected ? 3 : 2,
        dashArray: selected ? undefined : '6 3',
      }}
      eventHandlers={{ click: onClick }}
    >
      <Tooltip sticky direction="top" className="!bg-white !border-garden-200 !text-gray-800 !text-xs !font-medium !shadow-md">
        {bed.name}
      </Tooltip>
    </Polygon>
  );
}
